import getCombatantById from "./getCombatantById";
import getCombatantSlots from "./getCombatantSlots";
//------------------
// has future slots
//------------------
export default async function hasFutureSlots(parm) {
  // console.log("=============================");
  // console.log("hasFutureActions...");
  //------------
  // def return
  //------------
  let slot_parm = {
    futureActions: false,
    futureReactions: false,
    futureMarkers: false,
  };
  //---------------
  // get combatant
  //---------------
  let c = getCombatantById(parm.id);
  //
  return new Promise((resolve, reject) => {
    //---------------------
    // get combatant slots
    //---------------------
    let call = getCombatantSlots(c.slug);
    call
      .then((slots) => {
        //-----------------------------------
        // check future actions (true/false)
        //-----------------------------------
        slot_parm.futureActions = slots.actions.some((a) => {
          return (
            a.round > parm.this_round ||
            (a.round == parm.this_round && a.number > parm.this_number)
          );
        });
        //-------------------------------------
        // check future reactions (true/false)
        //-------------------------------------
        slot_parm.futureReactions = slots.reactions.some((a) => {
          return (
            a.round > parm.this_round ||
            (a.round == parm.this_round && a.number > parm.this_number)
          );
        });
        //-------------------------------------------
        // check future counter markers (true/false)
        //-------------------------------------------
        slot_parm.futureMarkers = slots.markers.some((a) => {
          return (
            (a.round > parm.this_round ||
              (a.round == parm.this_round && a.number > parm.this_number)) &&
            a.marker_name == "counter"
          );
        });
        //-------------
        // return flags
        //--------------
        resolve(slot_parm);
      })
      .catch((err) => {
        reject(err);
      });
  });
}
